import {getItem, setItem} from "@/utils/storage";

export default {
    namespaced: true,
    state: {
        token: getItem('token') || '',
        applyId: getItem('applyId') || ''
    },
    mutations: {
        /**
         * token
         */
        setToken(state, data) {
            state.token = data
            setItem('token', data)
        },
        /**
         * applyId
         */
        setApplyId(state, data) {
            state.token = data
            setItem('applyId', data)
        }
    },
    actions: {}
}
